import React, { useState, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import InfoBasicInformation from './NewInfoForms/InfoBasicInformation';
import InfoHeader from './NewInfoForms/InfoHeader';
import InfoUpdateUpload from './NewInfoForms/InfoUpdateUpload';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getInfo, updateInfo } from 'lib/apiService';

const schema = yup
  .object({
    title: yup.string().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const InfoUpdate = () => {
  let navigage = useNavigate();
  const { infoId } = useParams();

  // images
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getInfo(infoId);
        const newData = response?.data?.data;

        reset({
          title: newData?.title
        });

        const newFile = {};
        Object.assign(newFile, {
          path: newData.image.public_id,
          preview: newData.image.url
        });

        setImageUrls([newData.image]);
        setFiles([newFile]);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchData();
  }, [infoId]);

  const imageUploader = async image => {
    setLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setImageUrls({
      url: data.secure_url,
      public_id: data.public_id,
      name: data.display_name
    });

    setLoading(false);
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      data.image = imageUrls;

      updateInfo(infoId, data)
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай засагдлаа`, {
              theme: 'colored'
            });
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = '';
      }
      reset({ ...submittedValues });
      navigage('/info/info-list');
    }
  };

  const handleRemove = async path => {
    setFiles(files.filter(file => file.path !== path));

    const updatedImageUrls = imageUrls.filter(
      image => image.public_id !== path && image.uniqueId !== '200x200.jpg'
    );
    console.log(updatedImageUrls, 'xxxx');
    setImageUrls(updatedImageUrls);
    if (path) {
      axios
        .post(`${process.env.REACT_APP_FILE_URL}/removeimage`, {
          public_id: path,
          fileType: 'image'
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
      console.log('Image deleted successfully from S3.');
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={10}>
            <InfoHeader />
          </Col>
          <Col lg={10}>
            <InfoBasicInformation />

            <InfoUpdateUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
          </Col>
          <Col lg={2}>
            <div className="sticky-sidebar"></div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default InfoUpdate;
